import { Link as EELink } from '@micro-frontend-react/employee-experience/lib/Link';

export const Link = styled(EELink)`
  text-decoration: underline;
`;
